import { useEffect, useState } from "react";
import {
  dieStatusAPI,
  supplierDieAPI,
  locationAPI,
  customerAPI,
  dieMasterAPI,
  DieTypeAPI,
  ToolingAPI,
} from "../../utlis/apiService";
import { notify } from "../../common/Toast";
import Model from "../../common/Model";
import EntityAddModal from "../../common/EntityAddModal/index";
import InputField from "../../common/InputField";
import { AnimatePresence, motion } from "framer-motion";
import { MdClose } from "react-icons/md";
import Button from "../../common/Button";
import { IoMdClose } from "react-icons/io";
import { BsSave2, BsSave2Fill } from "react-icons/bs";
import { FaPaperPlane } from "react-icons/fa";

const DieForm = ({ initialData, onSubmit, onCancel, isEditing }) => {
  const today = new Date().toISOString()?.split("T")[0];
  const [formData, setFormData] = useState({
    id: 0,
    dieNumber: "",
    dieDate: today,
    subDieNo: "",
    invoiceNo: "",
    profileName: "",
    orderWeight: "",
    currentWeight: "",
    seriesName: "",
    customer_Id: "",
    widthHeight: "",
    supplier_Id: "",
    status_Id: 1,
    location_Id: "",
    range: "",
    range_Per: "",
    die_Pdf: null,
    die_Image: null,
    created_By: 1,
    toolingSize_Id: "",
    die_Type_Id: "",
    no_Of_Cavity: "",
    hardness: "",
    area_Sqmm: "",
    perimeter: "",
  });
  const [errors, setErrors] = useState({});
  const [pdfFile, setPdfFile] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [supplierOptions, setSupplierOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [locationOptions, setLocationOptions] = useState([]);
  const [dieTypeOptions, setDieTypeOptions] = useState([]);
  const [toolingSizeOptions, setToolingSizeOptions] = useState([]);
  const [attachedPdfName, setAttachedPdfName] = useState(null);
  const [modalType, setModalType] = useState(null);
  const loadDropdowns = async () => {
    try {
      const [customers, suppliers, statuses, locations, dieType, toolingSize] =
        await Promise.all([
          customerAPI.getAll(),
          supplierDieAPI.getAll(),
          dieStatusAPI.getAll(),
          locationAPI.getAll(),
          DieTypeAPI.getAll(),
          ToolingAPI.getAll(),
        ]);

      setCustomerOptions(
        customers.data.map((c) => ({
          value: c.customer_Id,
          label: c.name,
        }))
      );
      setSupplierOptions(
        suppliers.data.map((s) => ({
          value: s.supplier_Id,
          label: s.supplier_Name,
        }))
      );
      setStatusOptions(
        statuses.map((s) => ({ value: s.id, label: s.status_Name }))
      );
      if (!initialData && !formData.status_Id) {
        setFormData((prev) => ({ ...prev, status_Id: 1 }));
      }
      setLocationOptions(
        locations.data.map((l) => ({ value: l.location_Id, label: l.name }))
      );
      setDieTypeOptions(
        dieType.map((d) => ({ value: d.die_Type_Id, label: d.name }))
      );
      setToolingSizeOptions(
        toolingSize.map((t) => ({
          value: t.tooling_Size_Id,
          label: t.name,
        }))
      );
    } catch (err) {
      notify("Dropdown loading failed", "error");
    }
  };

  useEffect(() => {
    loadDropdowns();
  }, []);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.dieNumber.trim()) {
      newErrors.dieNumber = "Die Number is required.";
    }
    const orderWt = parseFloat(formData.orderWeight);
    if (!formData.orderWeight || isNaN(orderWt) || orderWt <= 0) {
      newErrors.orderWeight = "Order Weight is required and must be > 0.";
    }

    // const currentWt = parseFloat(formData.currentWeight);
    // if (!formData.currentWeight || isNaN(currentWt) || currentWt <= 0) {
    //   newErrors.currentWeight = "Current Weight is required and must be > 0.";
    // }

    if (!formData.status_Id) {
      newErrors.status_Id = "Status is required.";
    }

    if (!formData.supplier_Id) {
      newErrors.supplier_Id = "Supplier is required.";
    }

    if (!formData.location_Id) {
      newErrors.location_Id = "Location is required.";
    }

    if (
      formData.widthHeight &&
      !/^\d+(\.\d+)?\s*x\s*\d+(\.\d+)?$/i.test(formData.widthHeight)
    ) {
      newErrors.widthHeight = 'Invalid format. Use "100x50" or "75.5x25".';
    }

    if (Object.keys(newErrors).length > 0) {
      notify("Please correct the form errors.", "error");
      setErrors(newErrors);
      return false;
    }

    setErrors({});
    return true;
  };

  const handlePdfChange = (file) => {
    setPdfFile(file);
    setAttachedPdfName(file?.name || null);
  };

  useEffect(() => {
    if (initialData) {
      setFormData({
        ...formData,
        ...initialData,
        status_Id: initialData.status_Id || 1,
      });
      // if (initialData.die_Pdf) {
      //   const fileName = initialData.die_Pdf.split("/").pop();
      //   setAttachedPdfName(fileName);
      // } else {
      //   setAttachedPdfName(null);
      // }
      setImageFile(initialData.die_Image || null);
      setAttachedPdfName(initialData.die_Pdf?.split("/").pop() || null);
      if (initialData) {
        setFormData({
          ...initialData,
          die_Image: initialData.die_Image || null,
          die_Pdf: initialData.die_Pdf || null,
          dieDate: initialData.dieDate?.split("T")[0] || "",
        });
      }
    } else {
      setFormData({
        id: 0,
        dieNumber: "",
        dieDate: today,
        subDieNo: "",
        invoiceNo: "",
        profileName: "",
        orderWeight: "",
        currentWeight: "",
        seriesName: "",
        customer_Id: "",
        widthHeight: "",
        supplier_Id: "",
        status_Id: "",
        location_Id: "",
        range: "",
        range_Per: "",
        die_Pdf: null,
        die_Image: null,
        created_By: 1,
        tooling_Size: "",
        die_Type_Id: "",
        no_Of_Cavity: "",
        hardness: "",
        area_Sqmm: "",
        perimeter: "",
      });
      setAttachedPdfName(null);
    }
  }, [initialData]);

  const handleChange = (field, value) => {
    setFormData((prev) => {
      const next = { ...prev, [field]: value };

      if (field === "orderWeight" || field === "range_Per") {
        next.range = calcRange(next.orderWeight, next.range_Per);
      }
      return next;
    });
  };

  const handleSave = (type) => {
    if (!validateForm()) return;

    const formDataToSend = new FormData();

    formDataToSend.append("Id", formData.id);
    formDataToSend.append("DieNumber", formData.dieNumber);
    formDataToSend.append("DieDate", formData.dieDate);
    formDataToSend.append("SubDieNo", formData.subDieNo || "");
    formDataToSend.append("Invoice_No", formData.invoiceNo || "");
    formDataToSend.append("Profile_Name", formData.profileName || "");
    formDataToSend.append("Series_Name", formData.seriesName || "");
    formDataToSend.append("Customer_Id", formData.customer_Id || "");
    formDataToSend.append("Width_Height", formData.widthHeight || "");
    formDataToSend.append("CurrentWeight", formData.currentWeight);
    formDataToSend.append("OrderWeight", formData.orderWeight);
    formDataToSend.append("Status_Id", formData.status_Id);
    formDataToSend.append("Supplier_Id", formData.supplier_Id);
    formDataToSend.append("Location_Id", formData.location_Id);
    formDataToSend.append("Die_Range", formData.range);
    formDataToSend.append("Range_Per", formData.range_Per);
    formDataToSend.append("Tooling_Size", formData.toolingSize_Id || "");
    formDataToSend.append("Die_Type_Id", formData.die_Type_Id || "");
    formDataToSend.append("No_Of_Cavity", formData.no_Of_Cavity || "");
    formDataToSend.append("Hardness", formData.hardness || "");
    formDataToSend.append("Area_Sqmm", formData.area_Sqmm || "");
    formDataToSend.append("Perimeter", formData.perimeter || "");
    if (imageFile instanceof File) {
      formDataToSend.append("Die_Image", imageFile);
    } else if (formData.id === 0) {
      formDataToSend.append("Die_Image", null);
    }

    if (pdfFile) {
      formDataToSend.append("Die_Pdf", pdfFile);
    }

    if (formData.id === 0) {
      formDataToSend.append("Created_By", formData.created_By);
    } else {
      formDataToSend.append("Modify_By", 1);
    }
    onSubmit(formDataToSend, type);
  };

  const optionMap = {
    customer: {
      setter: setCustomerOptions,
      field: "customer_Id",
    },
    supplier: {
      setter: setSupplierOptions,
      field: "supplier_Id",
    },
    status: {
      setter: setStatusOptions,
      field: "status_Id",
    },
    location: {
      setter: setLocationOptions,
      field: "location_Id",
    },
    dieType: {
      setter: setDieTypeOptions,
      field: "die_Type_Id",
    },
    toolingSize: {
      setter: setToolingSizeOptions,
      field: "tooling_Size_Id",
    },
  };

  const handleEntityAddSuccess = async (type) => {
    const { setter } = optionMap[type];

    try {
      let updatedData;

      switch (type) {
        case "customer":
          updatedData = await customerAPI.getAll();
          setter(
            updatedData.data.map((c) => ({
              value: c.customer_Id,
              label: c.name,
            }))
          );
          break;
        case "supplier":
          updatedData = await supplierDieAPI.getAll();
          setter(
            updatedData.data.map((s) => ({
              value: s.supplier_Id,
              label: s.supplier_Name,
            }))
          );
          break;
        case "status":
          updatedData = await dieStatusAPI.getAll();
          setter(
            updatedData.map((s) => ({
              value: s.id,
              label: s.status_Name,
            }))
          );
          break;
        case "location":
          updatedData = await locationAPI.getAll();
          setter(
            updatedData.data.map((l) => ({
              value: l.location_Id,
              label: l.name,
            }))
          );
          break;
        case "dieType":
          updatedData = await DieTypeAPI.getAll();
          setter(
            updatedData.map((l) => ({
              value: l.die_Type_Id,
              label: l.name,
            }))
          );
          break;
        case "toolingSize":
          updatedData = await ToolingAPI.getAll();
          setter(
            updatedData.map((l) => ({
              value: l.tooling_Size_Id,
              label: l.name,
            }))
          );
          break;
        default:
          return;
      }

      setModalType(null);
    } catch (err) {
      notify("Failed to refresh dropdown", "error");
    }
  };

  const calcRange = (weightStr, perStr) => {
    const w = parseFloat(weightStr);
    const p = parseFloat(perStr);
    if (isNaN(w) || isNaN(p)) return "";
    const upper = w + (w * p) / 100;
    return `${w.toFixed(3)} - ${upper.toFixed(3)}`;
  };

  const onFileRemove = async (fileType, dieId) => {
    try {
      const apiCall =
        fileType === "image"
          ? dieMasterAPI.dieIMGDelete(dieId)
          : dieMasterAPI.diePDFDelete(dieId);

      const res = await apiCall;

      if (res.success) {
        notify(`${fileType.toUpperCase()} deleted successfully`, "success");
        if (fileType === "image") setImageFile(null);
        else setPdfFile(null);
      } else {
        notify(`Failed to delete ${fileType}`, "error");
      }
    } catch (error) {
      console.error(`Delete ${fileType} error:`, error);
      notify(`Something went wrong while deleting ${fileType}`, "error");
    }
  };

  return (
    <AnimatePresence>
      <div className="fixed inset-0 bg-slate-800 bg-opacity-75 flex items-center justify-center p-2 sm:p-4 z-9999">
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 100 }}
          transition={{
            type: "spring",
            stiffness: 300,
            damping: 30,
            duration: 0.5,
          }}
          className="bg-white rounded-lg shadow-xl w-full max-w-5xl max-h-[95vh] overflow-y-auto"
        >
          <div className="bg-primary text-white flex justify-between items-center p-4 sm:p-4">
            <h2 className="text-xl font-semibold uppercase">
              {isEditing ? " Update Die Record" : " Add New Die Record"}
            </h2>
            <Button
              onClick={onCancel}
              icon={MdClose}
              className="text-3xl "
            ></Button>
          </div>

          <form
            className="p-4 sm:p-4"
            onSubmit={(e) => {
              e.preventDefault();
              handleSave("close");
            }}
          >
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <InputField
                type="date"
                label="Die Entry Date"
                value={formData.dieDate}
                onChange={(v) => handleChange("dieDate", v)}
              />
              <InputField
                label="Die Number"
                required
                value={formData.dieNumber}
                onChange={(v) => handleChange("dieNumber", v)}
                placeholder="e.g., D-201"
                error={errors.dieNumber}
              />
              <InputField
                label="Sub Die No."
                value={formData.subDieNo}
                onChange={(v) => handleChange("subDieNo", v)}
                placeholder="e.g., A (Optional)"
              />
              <InputField
                label="Current Weight"
                value={formData.currentWeight}
                onChange={(v) => handleChange("currentWeight", v)}
                placeholder="e.g., A (Optional)"
              />
              <InputField
                label="Series Name"
                value={formData.seriesName}
                onChange={(v) => handleChange("seriesName", v)}
                placeholder="e.g., Architectural Series (Optional)"
              />

              <InputField
                label="Profile Name"
                value={formData.profileName}
                onChange={(v) => handleChange("profileName", v)}
                placeholder="e.g., Window Section XYZ"
              />
              <InputField
                label="Order Weight/12ft"
                required
                value={formData.orderWeight}
                onChange={(v) => handleChange("orderWeight", v)}
                placeholder="e.g., 2.500"
                unit="kg"
                error={errors.orderWeight}
              />

              <InputField
                type="selectWithAdd"
                label="Customer Name"
                value={formData.customer_Id}
                onChange={(selected) =>
                  handleChange("customer_Id", selected?.value)
                }
                options={customerOptions}
                onAddNewClick={() => setModalType("customer")}
              />
              <InputField
                label="Width * Height"
                value={formData.widthHeight}
                onChange={(v) => handleChange("widthHeight", v)}
                placeholder="e.g., 100×50 (Optional)"
              />
              <div>
                <label className="text-sm font-medium text-slate-700 mb-1">
                  Range (kg)
                </label>
                <div className="flex border border-slate-300 rounded-md overflow-hidden shadow-sm">
                  <input
                    value={formData.range_Per}
                    onChange={(e) => handleChange("range_Per", e.target.value)}
                    placeholder="10 %"
                    className="w-1/4 py-2 px-1 border-r border-slate-300 text-sm focus:outline-none"
                  />
                  <input
                    value={formData.range}
                    onChange={(e) => handleChange("die_Range", e.target.value)}
                    placeholder="2.500 - 2.750"
                    className="w-3/4 px-3 py-2 bg-gray-100 text-sm text-gray-700 focus:outline-none"
                  />
                </div>
              </div>
              <InputField
                label="Supplier"
                type="selectWithAdd"
                value={formData.supplier_Id}
                onChange={(selected) =>
                  handleChange("supplier_Id", selected?.value)
                }
                options={supplierOptions}
                onAddNewClick={() => setModalType("supplier")}
              />
              <InputField
                label="Invoice No."
                value={formData.invoiceNo}
                onChange={(v) => handleChange("invoiceNo", v)}
                placeholder="e.g., INV-123 (Optional)"
              />
              <InputField
                label="Status"
                type="selectWithAdd"
                value={formData.status_Id}
                onChange={(selected) =>
                  handleChange("status_Id", selected?.value)
                }
                options={statusOptions}
                onAddNewClick={() => setModalType("status")}
              />
              <InputField
                type="selectWithAdd"
                label="Location"
                value={formData.location_Id}
                onChange={(selected) =>
                  handleChange("location_Id", selected?.value)
                }
                options={locationOptions}
                onAddNewClick={() => setModalType("location")}
              />
              <InputField
                label="Die Type"
                type="selectWithAdd"
                value={formData.die_Type_Id}
                onChange={(selected) =>
                  handleChange("die_Type_Id", selected?.value)
                }
                options={dieTypeOptions}
                onAddNewClick={() => setModalType("dieType")}
              />
              <InputField
                label="No of Cavity"
                value={formData.no_Of_Cavity}
                onChange={(v) => handleChange("no_Of_Cavity", v)}
                placeholder="e.g., No of Cavity (Optional)"
              />
              <InputField
                label="Tooling Size"
                type="selectWithAdd"
                value={formData.toolingSize_Id}
                onChange={(selected) =>
                  handleChange("toolingSize_Id", selected?.value)
                }
                options={toolingSizeOptions}
                onAddNewClick={() => setModalType("toolingSize")}
              />

              <InputField
                label="Hardness"
                value={formData.hardness}
                onChange={(v) => handleChange("hardness", v)}
                placeholder="e.g., Hardness (Optional)"
              />
              <InputField
                label="Area (sq.mm)"
                value={formData.area_Sqmm}
                onChange={(v) => handleChange("area_Sqmm", v)}
                placeholder="e.g., Area (sq.mm) (Optional)"
              />
              <InputField
                label="Perimeter"
                value={formData.perimeter}
                onChange={(v) => handleChange("perimeter", v)}
                placeholder="e.g., Perimeter (Optional)"
              />
            </div>

            <div className="pt-2">
              <InputField
                type="pdf"
                label="Die PDF Attachment"
                onChange={handlePdfChange}
                accept=".pdf"
                currentFileName={attachedPdfName}
                error={errors?.pdf}
                idSuffix="die-pdf"
                dieId={formData.id}
                onFileRemove={onFileRemove}
                fileUrl={initialData?.die_Pdf}
              />
            </div>
            <div className="pt-2">
              <InputField
                type="image"
                label="Die Image Attachment"
                onChange={(file) => setImageFile(file)}
                currentFileName={
                  imageFile instanceof File
                    ? imageFile.name
                    : imageFile?.split("/")?.pop() || ""
                }
                previewUrl={imageFile}
                onFileRemove={onFileRemove}
                dieId={formData.id}
              />
            </div>

            <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
              <Button
                text="Cancel"
                className="bg-gray-100 hover:bg-gray-200 text-primary font-semibold text-md rounded-md p-2"
                iconSpacing="pr-1"
                borderColor="border border-gray-300"
                icon={IoMdClose}
                iconSize="w-4 h-4"
                onClick={onCancel}
              />

              <Button
                text={
                  isEditing
                    ? "Update & Add New (Blank)"
                    : "  Save & Add New (Blank)"
                }
                className="bg-orange/50  text-black font-semibold text-md border border-orange/20 rounded-md p-2"
                icon={BsSave2}
                iconSize="w-4 h-4"
                iconSpacing="pr-2"
                iconColor="text-black"
                onClick={() => handleSave("blank")}
              />
              <Button
                text={
                  isEditing
                    ? "Update & Add New (Same Invoice)"
                    : "  Save & Add New (Same Invoice)"
                }
                className="bg-orange/50  text-black font-semibold text-md border border-orange/20 rounded-md p-2"
                icon={BsSave2Fill}
                iconSize="w-4 h-4"
                iconSpacing="pr-2"
                iconColor="text-black"
                onClick={() => handleSave("sameInvoice")}
              />
              <Button
                text={isEditing ? "Update & Close" : " Save & Close"}
                className="bg-orange text-black font-semibold text-md rounded-md p-2"
                iconSpacing="pr-2"
                icon={FaPaperPlane}
                iconSize="w-4 h-4"
                iconColor="text-black"
                onClick={() => {
                  handleSave("close");
                }}
              />
            </div>
          </form>
          <Model
            isOpen={!!modalType}
            onClose={() => setModalType(false)}
            name={`Add ${modalType}`}
          >
            <EntityAddModal
              type={modalType}
              onClose={(newOption) => {
                setModalType(null);
                handleEntityAddSuccess(modalType, newOption);
              }}
            />
          </Model>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default DieForm;
